import React, { useEffect, useState } from "react";
import { BootstrapModal } from "../BootstrapModal/Modal";
import { CgClose } from "react-icons/cg";
import Button from "../Button/Button";
import { InputField1 } from "../InputField1/InputField1";
import { SimpleSelect1 } from "../SimpleSelect/SimpleSelect1";
import { useAddNewAddress, useGetCities } from "../../hooks/useCrm";
import { SimpleTextArea } from "../SimpleTextArea/SimpleTextArea";
const initvalue = {
  IdS0alesOpportunities: null,
  RecipientName: "",
  RecipientPhone: "",
  IdCity: null,
  Address: "",
};
export const AddAddressModal = ({ show, handleClose, userdata }) => {
  const [button] = useState(false);
  const { data: cities } = useGetCities();
  const [form, setForm] = useState(initvalue);

  const Cities = cities?.data?.ProvincesAndCities;
  const CitiesOptions = Cities?.map((city) => {
    return {
      value: city.IdCities,
      label: city.NameProvinces + "-" + city.NameCities,
    };
  });
  useEffect(() => {
    setForm({
      ...initvalue,
      IdS0alesOpportunities:
        userdata?.sales_opportunities[0].IdS0alesOpportunities,
    });
  }, [userdata]);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const { mutateAsync: AddAddress, isLoading: NewAddressLoading } =
    useAddNewAddress();
  const handleAddNewAddress = async (address) => {
    await AddAddress(address);
  };
  return (
    <BootstrapModal
      modaltitle="اضافه کردن آدرس"
      handleClose={handleClose}
      show={show}
      moreButton={button}
      size="lg"
      closebutton={
        <Button style={{ width: "40px", border: "none" }} onclick={handleClose}>
          <CgClose />
        </Button>
      }
    >
      <div className="row">
        <div className="col-lg-4 col-sm-12 col-md-12">
          <InputField1
            onChange={handleChange}
            name={"RecipientName"}
            label={"نام و نام خانوادگی تحویل گیرنده"}
            type={"text"}
            placeholder={"نام و نام خانوادگی تحویل گیرنده"}
            id={"NameAndFamily"}
            className={"form-control"}
          ></InputField1>
        </div>
        <div className="col-lg-4 col-sm-12 col-md-12">
          <InputField1
            onChange={handleChange}
            name={"RecipientPhone"}
            label={"شماره تماس تحویل گیرنده"}
            type={"text"}
            placeholder={"شماره تماس تحویل گیرنده"}
            id={"PhoneNumber"}
            className={"form-control"}
          ></InputField1>
        </div>
        <div className="col-lg-4 col-sm-12 col-md-12">
          <SimpleSelect1
            label={"شهر تحویل گیرنده"}
            res={CitiesOptions}
            onChange={(e) =>
              setForm({
                ...form,
                IdCity: e.value,
              })
            }
          />
        </div>
        <div className="col-lg-12 col-sm-12 col-md-12">
          <SimpleTextArea
            onChange={handleChange}
            name={"Address"}
            label="آدرس دقیق"
            placeholder="آدرس را وارد کنید"
            cols="10"
            rows="3"
          />
        </div>
        <div className="col-12">
          <Button
            bgColor="#009ef7"
            color="#fff"
            onclick={() => {
              handleAddNewAddress(form);
              handleClose();
            }}
          >
            تایید
          </Button>
        </div>
      </div>
    </BootstrapModal>
  );
};
